<div class="wrap">
    <div class="dash">




        <form class="camera_select" [formGroup]="choiceDateForm" (ngSubmit)="onSubmit(false)">
            <mat-form-field appearance="outline">
                <mat-label>Du</mat-label>
                <input matInput [matDatepicker]="from" formControlName="from">
                <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
                <mat-datepicker #from></mat-datepicker>
            </mat-form-field>
            <span>-</span>
            <mat-form-field appearance="outline">
                <mat-label>Au</mat-label>
                <input matInput [max]="today" [matDatepicker]="to" formControlName="to">
                <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
                <mat-datepicker #to></mat-datepicker>
            </mat-form-field>
        </form>



        <agm-map [latitude]='lat' [longitude]='lng'>
            <agm-marker-cluster
                imagePath="https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m">
                <agm-marker *ngFor="let markerWaste of markersWaste" [latitude]="markerWaste.lat"
                    [longitude]="markerWaste.lng" [iconUrl]="markerWaste.iconUrl">
                    <agm-info-window #infoWindow>
                        {{ markerWaste.label }}
                    </agm-info-window>
                </agm-marker>
            </agm-marker-cluster>
        </agm-map><br>

        <table [dataSource]="dataSource" mat-table class="mat-elevation-z8">


            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Nom </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef> Date </th>
                <td mat-cell *matCellDef="let element"> {{element.date|date:'short'}} </td>
            </ng-container>

            <ng-container matColumnDef="alerte">
                <th mat-header-cell *matHeaderCellDef> Alerte </th>
                <td mat-cell *matCellDef="let element"> {{element.alerte}} </td>
            </ng-container>

            <ng-container matColumnDef="source">
                <th mat-header-cell *matHeaderCellDef>Lien </th>
                <td mat-cell *matCellDef="let element"> {{element.source}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>


    </div>
</div>